import { useState } from "react";
import { api } from "@shared/api/client";
import type { Iso2700127701ControlModificacion, Iso2700127701ControlModificacionPayload } from "../../types/control-modificaciones";
import { createEmptyControlModificacionForm } from "../../types/control-modificaciones";
import { Iso2700127701ControlModificacionDeleteModal } from "./Iso2700127701ControlModificacionDeleteModal";
import { Iso2700127701ControlModificacionFormModal } from "./Iso2700127701ControlModificacionFormModal";
import { Iso2700127701ControlModificacionesTable } from "./Iso2700127701ControlModificacionesTable";

type Props = { rows: Iso2700127701ControlModificacion[]; loading: boolean; error: string | null; baseEndpoint: string; onReload: () => Promise<void> | void };

export function Iso2700127701ControlDocumentalPanel({ rows, loading, error, baseEndpoint, onReload }: Props) {
  const [row, setRow] = useState<Iso2700127701ControlModificacion | null>(null);
  const [open, setOpen] = useState(false);
  const [deleteRow, setDeleteRow] = useState<Iso2700127701ControlModificacion | null>(null);
  const [value, setValue] = useState<Iso2700127701ControlModificacionPayload>(createEmptyControlModificacionForm());
  const [submitting, setSubmitting] = useState(false);
  const [formError, setFormError] = useState<string | null>(null);

  const create = () => { setRow(null); setValue(createEmptyControlModificacionForm()); setFormError(null); setOpen(true); };
  const edit = (selected: Iso2700127701ControlModificacion) => { setRow(selected); setValue({ fecha: selected.fecha, modificaciones_realizadas: selected.modificaciones_realizadas }); setFormError(null); setOpen(true); };
  const submit = async () => {
    setSubmitting(true); setFormError(null);
    try {
      if (row) await api.put(`${baseEndpoint}/${row.id}`, value); else await api.post(baseEndpoint, value);
      setOpen(false); await onReload();
    } catch { setFormError("No se pudo guardar la modificación."); }
    finally { setSubmitting(false); }
  };
  const remove = async () => {
    if (!deleteRow) return;
    setSubmitting(true);
    try { await api.delete(`${baseEndpoint}/${deleteRow.id}`); setDeleteRow(null); await onReload(); }
    finally { setSubmitting(false); }
  };

  return <>
    <Iso2700127701ControlModificacionesTable rows={rows} loading={loading} error={error} onRetry={() => void onReload()} onCreate={create} onEdit={edit} onDelete={setDeleteRow} />
    <Iso2700127701ControlModificacionFormModal open={open} title={row ? "Editar modificación" : "Nueva modificación"} value={value} submitting={submitting} error={formError} onChange={setValue} onClose={() => setOpen(false)} onSubmit={() => void submit()} />
    <Iso2700127701ControlModificacionDeleteModal row={deleteRow} submitting={submitting} onClose={() => setDeleteRow(null)} onConfirm={() => void remove()} />
  </>;
}
